import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import { perf } from '@databases/logs/performance';
import React from 'react';

import StandaloneApp from './standalone-app';

const AppWithLocale = () => {
  const locale = useLocale();
  perf.timeLog('app-initialization', 'app-with-locale');

  return (
    <IntlProviderWithMessages locale={locale}>
      <StandaloneApp />
    </IntlProviderWithMessages>
  );
};

export default AppWithLocale;
